{
    "Accessibility menu": "Menyu ya Ufikivu",
    "Close": "Funga",
    "Content adjustments": "Marekebisho ya Maudhui",
    "Navigation adjustments": "Marekebisho ya Uelekezaji",
    "Text Align": "Mpangilio wa Maandishi",
    "Align Left": "Panga Kushoto",
    "Align Center": "Pangilia Katikati",
    "Align Right": "Pangilia Kulia",
    "Adjust Font Size": "Rekebisha Ukubwa wa Herufi",
    "Highlight Title": "Angazia Kichwa",
    "Highlight Links": "Angazia Viungo",
    "Readable Font": "Herufi Zinazosomeka",
    "Colour adjustments": "Marekebisho ya Rangi",
    "Dark Contrast": "Tofauti ya Giza",
    "Light Contrast": "Tofauti ya Mwangaza",
    "High Contrast": "Tofauti ya Juu",
    "High Saturation": "Ujazaji wa Juu",
    "Low Saturation": "Ujazaji wa Chini",
    "Monochrome": "Rangi Moja",
    "Tools": "Zana",
    "Reading Guide": "Mwongozo wa Kusoma",
    "Big Cursor": "Mshale Mkubwa",
    "Increase Font Size": "Ongeza Ukubwa wa Herufi",
    "Decrease Font Size": "Punguza Ukubwa wa Herufi",
    "Letter Spacing": "Nafasi ya Herufi",
    "Line Height": "Urefu wa Mstari",
    "Font Weight": "Uzito wa Herufi",
    "Dyslexia Font": "Herufi za Dyslexia",
    "Language": "Lugha",
    "Accessibility widget": "Fungua Menyu ya Ufikivu",
    "Accessibility Profiles": "Wasifu wa Ufikivu",
    "Cognitive Disability": "Ulemavu wa Akili",
    "Seizure Safe": "Salama dhidi ya Mshtuko",
    "Accessibility statement": "Taarifa ya Ufikivu",
    "ADHD": "ADHD",
    "Low Vision": "Uoni Hafifu",
    "Pause Animations": "Simamisha Animations",
    "Animation paused": "Mwendo umesimamishwa",
    "Reset all settings": "Weka upya mipangilio",
    "Shortcut:": "Njia ya mkato:",
    "Epilepsy Safe Mode": "Hali Salama kwa Kifafa",
    "Mute sounds": "Zima sauti",
    "Page read": "Soma ukurasa",
    "Page read controls": "Vidhibiti vya kusoma ukurasa",
    "Pause": "Sitisha",
    "Resume": "Endelea",
    "Stop": "Simamisha",
    "Settings": "Mipangilio",
    "Speed": "Kasi",
    "Voice": "Sauti",
    "Close accessibility menu": "Funga menyu ya ufikivu",
    "Back to accessibility menu": "Rudi kwenye menyu ya ufikivu",
    "Search languages": "Tafuta lugha",
    "Selected language": "Lugha iliyochaguliwa",
    "View accessibility statement (opens in new window)": "Tazama taarifa ya ufikivu (hufunguka katika dirisha jipya)",
    "Visit CookieYes website (opens in new window)": "Tembelea tovuti ya CookieYes (hufunguka katika dirisha jipya)",
    "Reset all accessibility settings to default": "Weka upya mipangilio yote ya ufikivu kuwa chaguo-msingi"
}
